/** Spanish org-admin UI copy (sidebar, tabs, dialogs, billing tab). */

import {
  WC2026_ORG_BILLING_DISCLOSURE,
  WC2026_ORG_BILLING_DISCLOSURE_SHORT,
} from '../../../shared/constants/wc2026OrgBillingDisclosure.constants'

export const accountAdminCopyEs = {
  backToSite: '← Volver al sitio',
  ORG_DRAWER_PARENT_FALLBACK: 'Organizaciones',
  FRIENDS_ENTRY_LABEL: 'Administrar organización',
  FRIENDS_ENTRY_HINT: 'Marca y miembros',
  START_HERE: 'Comenzar aquí',
  START_HERE_INTRO:
    'Usa la navegación de la organización para moverte entre Comenzar aquí, Marca, Miembros y Configuración. Luego:',
  OPEN_MENU: 'Abrir menú',
  BRANDING: 'Marca',
  MEMBERS: 'Miembros',
  SETTINGS: 'Configuración',
  PLAN_BILLING: 'Plan',
  PLAN_BILLING_INTRO:
    'Mejora tu organización en la web, gestiona métodos de pago y consulta facturas en el portal de clientes de Stripe.',
  PLAN_BILLING_CURRENT: 'Plan actual',
  PLAN_BILLING_RENEWS: 'Renueva o finaliza el periodo',
  PLAN_BILLING_STATUS: 'Estado de la suscripción',
  PLAN_BILLING_UPGRADE_BUSINESS: 'Mejorar a Business',
  PLAN_BILLING_UPGRADE_ENTERPRISE: 'Mejorar a Enterprise',
  PLAN_BILLING_PORTAL: 'Gestionar facturación y facturas',
  PLAN_BILLING_WEB_ONLY: 'Los planes están disponibles en la web.',
  INVOICE_DETAILS: 'Facturación y factura',
  INVOICE_DETAILS_WEB_ONLY: 'Facturación y factura están disponibles en la web.',
  MANAGE_PLAN_BILLING: 'Gestionar plan',
  COMPARE_PLANS: 'Comparar planes',
  NO_ORG_TITLE: 'Aún no hay organización',
  NO_ORG_SUBTITLE: 'Crea una para gestionar la marca y los miembros, o únete con un código.',
  CREATE_PLACEHOLDER: 'Nombre de la organización',
  CREATE_CTA: 'Crear organización',
  JOIN_PLACEHOLDER: 'Código de unión',
  JOIN_CTA: 'Unirse',
  MEMBER_ONLY_TITLE: 'Acceso de miembro',
  MEMBER_ONLY_MESSAGE:
    'Solo los administradores de la organización pueden cambiar la marca y la configuración. Contacta a tu administrador si necesitas actualizaciones.',
  MEMBER_INVITE_RETURN_TITLE: 'Ya estás en esta organización',
  MEMBER_INVITE_RETURN_MESSAGE:
    'Este enlace es para compañeros que aún no se han unido. Has iniciado sesión como miembro, así que no hay nada que aceptar. Solo los administradores pueden cambiar la marca y la configuración.',
  B2B_LOGO_MAX_COUNT: 1,
  BRAND_IMAGERY_SECTION_TITLE: 'Imagen de marca',
  UPLOAD_LOGOS: 'Subir logo',
  LOGO_TILE_LABEL: 'Logo',
  LOGO_TILE_EMPTY: 'Añadir un logo',
  BANNER_TILE_LABEL: 'Banner del squad',
  BANNER_TILE_EMPTY: 'Añadir un banner',
  UPLOAD_BANNER: 'Subir banner',
  REPLACE_BANNER: 'Reemplazar banner',
  REMOVE_BANNER: 'Eliminar banner',
  REMOVE_BANNER_CONFIRM_TITLE: '¿Eliminar este banner?',
  REMOVE_BANNER_CONFIRM_MESSAGE: 'El squad volverá al gradiente de color de marca.',
  LOGOS_UPLOAD_LIMITS_PLACEHOLDER: '',
  LOGOS_UPLOAD_HINT:
    'PNG, JPG, WebP o SVG. Máx. 2 MB. Cuadrado (1:1), 512–1024 px por lado. Se prefiere PNG transparente.',
  BANNER_UPLOAD_HINT:
    'PNG, JPG o WebP. Máx. 2 MB. Proporción 4:1 — se recomienda 1600×400 px, mín. 1200×300 px.',
  USE_BANNER_BACKGROUND_LABEL: 'Usar la imagen del banner como fondo del squad',
  USE_BANNER_BACKGROUND_HINT:
    'Cuando está activado, el hero del squad muestra tu imagen de banner en lugar del gradiente de colores primario/secundario.',
  USE_BANNER_BACKGROUND_DISABLED_HINT: 'Sube primero una imagen de banner para activar esta opción.',
  USE_BANNER_BACKGROUND_SAVED: 'Guardado',
  REMOVE_LOGO: 'Eliminar',
  DOWNLOAD_LOGO: 'Descargar',
  DOWNLOAD_LOGO_ERROR: 'No se pudo descargar la imagen',
  REMOVE_LOGO_CONFIRM_TITLE: '¿Eliminar este logo?',
  REMOVE_LOGO_CONFIRM_MESSAGE: 'Ya no aparecerá para tu organización.',
  LOGO_FILE_TOO_LARGE: 'Esa imagen supera el límite de 2 MB. Prueba con un archivo más pequeño.',
  SAVE_COLORS: 'Guardar colores',
  COLORS_SAVED: 'Colores guardados',
  PRIMARY: 'Primario',
  SECONDARY: 'Secundario',
  COLOR_PRESETS: 'Preajustes',
  COLOR_PALETTE_LABEL: 'Paleta',
  COLOR_PALETTE_SATURATION_A11Y: 'Saturación y brillo. Arrastra para elegir el color.',
  COLOR_PALETTE_HUE_A11Y: 'Tono. Arrastra para cambiar el color.',
  CUSTOM_HEX_LABEL: 'Personalizado (hex)',
  HEX_PLACEHOLDER: '#RRGGBB',
  JOIN_CODE: 'Código de unión',
  SQUAD_JOIN_CODE: 'Código de unión del squad',
  ADD_MEMBERS_TITLE: 'Añadir compañeros',
  ADD_MEMBERS_BODY:
    'Comparte el enlace de invitación a continuación. Los compañeros inician sesión en Zporti y abren el enlace para unirse a esta organización.',
  ADD_MEMBERS_BODY_WC_SINGLE_PRIMARY:
    'Comparte el enlace de invitación a continuación para que los compañeros inicien sesión y se unan a esta organización — se añaden automáticamente a tu squad vinculado de Football 2026. Para amigos fuera de la organización, comparte una invitación al squad desde Football 2026 → Squads (no desde esta página).',
  MEMBERS_DIRECTORY: 'Directorio de miembros',
  MEMBERS_ADMIN_HINT:
    'Los administradores pueden gestionar la marca, los miembros y la configuración. Usa Hacer admin / Degradar / Eliminar en la columna Acciones.',
  MEMBERS_TABLE_NAME: 'Nombre',
  MEMBERS_TABLE_EMAIL: 'Correo electrónico',
  MEMBERS_TABLE_ROLE: 'Rol',
  MEMBERS_TABLE_JOINED: 'Se unió',
  MEMBERS_TABLE_ACTIONS: 'Acciones',
  MEMBERS_TABLE_NO_ACTIONS_VISIBLE: 'Sin acciones',
  MEMBER_ACTION_LOADING_A11Y: 'Actualizando miembro',
  MEMBERS_BULK_REMOVE_LOADING_A11Y: 'Eliminando miembros seleccionados',
  MEMBERS_TABLE_NO_ACTIONS_A11Y:
    'Sin acciones. No puedes editar tu propia fila, o no hay nada que cambiar para este miembro.',
  ROLE_LABEL_ADMIN: 'Administrador',
  ROLE_LABEL_MEMBER: 'Miembro',
  MEMBERS_EMPTY: 'Aún no hay miembros.',
  MEMBER_ROW_YOU_INLINE: ' (Tú)',
  INVITE_LINK: 'Enlace de invitación',
  INVITE_LINK_HINT: 'Comparte este enlace para que los compañeros inicien sesión y se unan a tu organización.',
  INVITE_LINK_HINT_WC:
    'Este enlace abre el flujo de unión a la organización. Después de iniciar sesión, se unen a la org y a tu squad vinculado de Football 2026 juntos.',
  INVITE_LINK_QR_HINT: 'Escanea con la cámara del teléfono para abrir este enlace.',
  INVITE_LINK_QR_A11Y:
    'Código QR del enlace de invitación. Escanea con la cámara del teléfono para abrir la página de unión.',
  COPY_INVITE_LINK: 'Copiar enlace',
  VIEW_LINKED_SQUAD: 'Ver página del squad',
  VIEW_LINKED_SQUAD_A11Y: 'Abrir el squad vinculado de Football 2026 para previsualizar resultados',
  SEATS: 'Plazas',
  SEATS_UNLIMITED: 'Ilimitadas',
  MAKE_ADMIN: 'Hacer admin',
  MAKE_ADMIN_TITLE: '¿Hacer administrador a este miembro?',
  MAKE_ADMIN_MESSAGE:
    'Podrá gestionar la marca, los miembros y la configuración de la organización.',
  DEMOTE_ADMIN: 'Degradar',
  DEMOTE_ADMIN_TITLE: '¿Degradar a este administrador?',
  DEMOTE_ADMIN_MESSAGE: 'Conservará el acceso como miembro pero perderá los controles de administrador.',
  REMOVE_MEMBER: 'Eliminar',
  MEMBERS_BULK_SELECT: 'Seleccionar varios',
  MEMBERS_BULK_CANCEL_SELECT: 'Cancelar selección',
  MEMBERS_BULK_REMOVE: 'Eliminar seleccionados',
  MEMBERS_BULK_REMOVE_TITLE: '¿Eliminar miembros seleccionados?',
  MEMBERS_BULK_REMOVE_MESSAGE:
    'Perderán el acceso a esta organización (y al squad vinculado de Football 2026, si lo hay). Esto no se puede deshacer.',
  MEMBERS_BULK_REMOVE_CONFIRM: 'Eliminar',
  MEMBERS_BULK_ROW_CHECKBOX_A11Y: 'Seleccionar miembro para eliminación masiva',
  MEMBERS_BULK_CANCEL_DIALOG: 'Cancelar',
  MEMBERS_BULK_REMOVE_FAILED: 'Error en la eliminación masiva',
  MEMBERS_INVITE_LINK_COPIED: 'Enlace copiado',
  membersBulkRemoveSummary: (removed: number, skipped: number) =>
    `Eliminados ${removed}; omitidos ${skipped}`,
  membersBulkRemoveDone: (removed: number) => `Eliminados ${removed}`,
  MEMBERS_BULK_SELECT_ALL_A11Y: 'Seleccionar o desmarcar todos los miembros excepto tú',
  ACCOUNT_NAME: 'Nombre de la organización',
  SAVE_NAME: 'Guardar nombre',
  WC_LINKED_SQUAD_SECTION_TITLE: 'Squad vinculado de Football 2026',
  WC_LINKED_SQUAD_SECTION_BODY_LINKED:
    'Es el mismo squad que ves en Football 2026 → Squads. Cambia el nombre del squad aquí o en esa pantalla. Comparte el enlace de invitación de la organización desde la pestaña Miembros: los nuevos miembros se unen primero a la org, se añaden automáticamente a este squad y luego abren el squad.',
  WC_LINKED_SQUAD_SECTION_BODY_NOT_LINKED:
    'Pega un código de invitación de squad de Football 2026 para vincular ese squad a esta organización. Tras vincular, cualquiera que se una con el enlace de invitación de la organización en la pestaña Miembros se añade automáticamente al squad.',
  WC_LINKED_SQUAD_NAME_LABEL: 'Nombre del squad',
  WC_LINKED_SQUAD_INVITE_CODE_LABEL: 'Código de invitación del squad',
  WC_LINKED_SQUAD_CODE_PLACEHOLDER: 'Pegar código de invitación del squad',
  WC_LINKED_SQUAD_SAVE_NAME: 'Guardar nombre del squad',
  WC_LINKED_SQUAD_LINK_SQUAD: 'Vincular squad',
  ORG_ONLY_JOIN_CODE_TITLE: 'Invitación a la organización',
  ORG_ONLY_JOIN_CODE_BODY:
    'Comparte el enlace de invitación para que las personas se unan primero a la organización; se añaden automáticamente al squad y pueden abrirlo desde Football 2026 → Squads.',
  COPY_ORG_INVITE_LINK: 'Copiar enlace de invitación',
  PLAN_TIER: 'Plan',
  MEMBERSHIP_POLICY_TITLE: 'Límite de miembros',
  MEMBERSHIP_POLICY_UNLIMITED_LABEL: 'Miembros ilimitados',
  MEMBERSHIP_POLICY_UNLIMITED_APPROVED_HELP:
    'Las uniones ilimitadas por enlace de invitación están habilitadas para esta organización tras la aprobación de Zporti.',
  MEMBERSHIP_POLICY_FROM_PLAN_HELP:
    'Tu plan incluye miembros ilimitados por enlace de invitación. No se requiere acción.',
  MEMBERSHIP_POLICY_PENDING_HELP:
    'Tu solicitud está pendiente. Zporti habilitará miembros ilimitados tras la revisión.',
  MEMBERSHIP_POLICY_LIMITED_HELP:
    'Si está desmarcado, las uniones por enlace de invitación están limitadas por tu límite de plazas (100 por defecto en Starter).',
  MEMBERSHIP_POLICY_ENABLE_DIALOG_TITLE: '¿Solicitar miembros ilimitados?',
  MEMBERSHIP_POLICY_ENABLE_DIALOG_MESSAGE:
    'Esto envía una solicitud a Zporti. Revisaremos y habilitaremos miembros ilimitados por enlace de invitación para tu organización. Puedes seguir usando tu límite de plazas actual hasta entonces. ¿Enviar la solicitud ahora?',
  MEMBERSHIP_POLICY_ENABLE_DIALOG_CONFIRM: 'Enviar solicitud',
  MEMBERSHIP_POLICY_REQUEST_SENT: 'Solicitud enviada',
  MEMBERSHIP_POLICY_CANCEL_REQUEST_LINK: 'Cancelar solicitud',
  MEMBERSHIP_POLICY_CANCEL_DIALOG_TITLE: '¿Cancelar solicitud de miembros ilimitados?',
  MEMBERSHIP_POLICY_CANCEL_DIALOG_MESSAGE:
    'Esto retira tu solicitud pendiente. Zporti será notificado de que la cancelaste.',
  MEMBERSHIP_POLICY_CANCEL_CONFIRM: 'Cancelar solicitud',
  MEMBERSHIP_POLICY_CANCEL_DONE: 'Solicitud cancelada',
  BILLING_GATE_LOCKED_TITLE: 'Completa la facturación para desbloquear',
  BILLING_GATE_LOCKED_BODY:
    'Configura el plan de tu organización para acceder a marca, miembros y configuración.',
  BILLING_GATE_GO_TO_BILLING: 'Ir al plan',
  DEACTIVATE: 'Desactivar organización',
  DEACTIVATE_CONFIRM_TITLE: '¿Desactivar organización?',
  DEACTIVATE_CONFIRM_MESSAGE:
    'Los miembros perderán los beneficios de la organización hasta que el soporte la reactive.',
  INACTIVE_TITLE: 'Inactiva',
  INACTIVE_BODY:
    'Esta organización está desactivada. Puedes reactivarla si fue un error.',
  REACTIVATE: 'Reactivar',
  REMOVE_MEMBER_TITLE: '¿Eliminar miembro?',
  REMOVE_MEMBER_MESSAGE: 'Perderá el acceso a esta organización.',
  LEAVE_ORG_TITLE: '¿Abandonar esta organización?',
  LEAVE_ORG_MESSAGE:
    'Perderás el acceso a las herramientas de marca y miembros de esta org. Después puedes crear o unirte a otra organización.',
  LEAVE_ORG_CONFIRM: 'Abandonar organización',
  LEAVE_ORG_MEMBER_HINT:
    'Para dejar de usar los beneficios de esta organización, puedes abandonarla. Tu administrador puede volver a añadirte con una invitación.',
  LEAVE_ORG_DONE_TITLE: 'Abandonaste la organización',
  LEAVE_ORG_DONE_MESSAGE: 'Puedes crear una nueva organización o unirte a una con un código desde esta página.',
  LEAVE_ORG_SOLE_ADMIN_HINT:
    'Eres el único administrador. Promueve a otro miembro a administrador en Miembros y luego podrás abandonar.',
  DEACTIVATE_PERMANENT_DELETE_FOOTNOTE:
    'Tras la desactivación, aparece en esta pestaña una sección de eliminación permanente con un campo de confirmación, debajo de Abandonar organización.',
  DELETE_ORG_SECTION_TITLE: 'Eliminar permanentemente',
  DELETE_ORG_SECTION_BODY:
    'Esto elimina la organización y todas las membresías de nuestros sistemas. Escribe la frase exacta a continuación: la palabra delete en minúsculas, un espacio, y luego el nombre de tu organización exactamente como está guardado.',
  DELETE_ORG_NAME_LABEL: 'Escribe esta frase exactamente',
  DELETE_ORG_BUTTON: 'Eliminar organización para siempre',
  DELETE_ORG_DIALOG_TITLE: '¿Eliminar esta organización para siempre?',
  DELETE_ORG_DIALOG_MESSAGE:
    'Esto no se puede deshacer. Todos los miembros perderán el acceso y se eliminarán los datos de marca.',
  setupGuide: {
    TITLE: 'Orden de configuración sugerido',
    LINE_BRANDING_BEFORE: 'Configura tus ',
    LINE_BRANDING_LINK: 'logos y colores de marca',
    LINE_BRANDING_AFTER: ' para que los miembros reconozcan tu organización.',
    LINE_MEMBERS_BEFORE: 'Invita a tu equipo desde ',
    LINE_MEMBERS_AFTER: ' usando tu enlace de invitación o código de unión.',
    LINE_SETTINGS_BEFORE: 'Revisa el nombre de la organización y el plan en ',
    LINE_SETTINGS_AFTER: '.',
  },
  navShort: {
    START_HERE: 'Inicio',
    BRANDING: 'Marca',
    MEMBERS: 'Miembros',
    SETTINGS: 'Ajustes',
    PLAN_BILLING: 'Plan',
    INVOICE_DETAILS: 'Facturación',
  },
  navLockedA11ySuffix: ' — completa la facturación para desbloquear',
  brandingPreview: {
    SECTION_LABEL: 'Vista previa',
    SQUAD_PLACEHOLDER_NAME: 'Tu escuadra',
    COMPANY_NAME_PLACEHOLDER: 'Tu organización',
    COLOR_PRIMARY_LABEL: 'Color principal',
    COLOR_SECONDARY_LABEL: 'Color secundario',
    HERO_BACK_LABEL: 'Escuadras',
    HERO_COMPANY_GROUP_LABEL: 'Grupo de empresa',
    HERO_EMPLOYEES_LABEL: 'miembros',
  },
  sso: {
    TITLE: 'Inicio de sesión corporativo (SSO)',
    BODY:
      'Restringe esta organización a usuarios con un dominio de correo corporativo específico. Cuando está activado, los nuevos miembros que inicien sesión con Google usando ese dominio se añaden automáticamente — sin enlace de invitación. Los miembros existentes no se ven afectados.',
    CHECKBOX_LABEL: 'Restringir al dominio de correo corporativo',
    DOMAIN_PLACEHOLDER: 'acme.com',
    SAVE_BUTTON: 'Guardar ajustes SSO',
    INVALID_DOMAIN: 'Introduce un dominio válido (p. ej. acme.com)',
    domainRestricted: (domain: string) => `Dominio restringido a @${domain}`,
    DOMAIN_REMOVED: 'Restricción de dominio eliminada',
    SAVE_FAILED: 'No se pudieron guardar los ajustes SSO',
  },
  billing: {
    ORGANIZATION_PLAN_LABEL: 'Plan de organización',
    PLAN_PICKER_HEADING: 'Elige tu plan',
    PLAN_PICKER_SUBHEADING:
      'Acceso organizacional único WC 2026: marca, plazas de miembros y equipo vinculado durante el torneo.',
    PLAN_BUSINESS_NAME: 'Business',
    PLAN_BUSINESS_PRICE: 'Desde $450',
    PLAN_BUSINESS_TAGLINE:
      'Tarifa org única de autoservicio. Elige tu nivel de plazas y paga una vez por el acceso al torneo WC 2026.',
    ORG_BILLING_DISCLOSURE: WC2026_ORG_BILLING_DISCLOSURE,
    ORG_BILLING_DISCLOSURE_SHORT: WC2026_ORG_BILLING_DISCLOSURE_SHORT,
    PLAN_BUSINESS_CTA: 'Comenzar',
    PLAN_ENTERPRISE_NAME: 'Enterprise',
    PLAN_ENTERPRISE_PRICE: 'Personalizado',
    PLAN_ENTERPRISE_TAGLINE:
      'Precios personalizados para grandes organizaciones. Contáctanos y diseñaremos un plan que encaje.',
    PLAN_ENTERPRISE_CTA: 'Contáctanos',
    CUSTOM_FORM_NAME_LABEL: 'Tu nombre',
    CUSTOM_FORM_NAME_PLACEHOLDER: 'Jane Smith',
    CUSTOM_FORM_EMAIL_LABEL: 'Correo de trabajo',
    CUSTOM_FORM_EMAIL_PLACEHOLDER: 'jane@company.com',
    CUSTOM_FORM_MESSAGE_LABEL: 'Mensaje (opcional)',
    CUSTOM_FORM_MESSAGE_PLACEHOLDER: 'Cuéntanos sobre tu organización y lo que necesitas.',
    CUSTOM_FORM_SUBMIT: 'Enviar consulta',
    CUSTOM_FORM_SENT: '¡Nos pondremos en contacto pronto!',
    PERSONAL_PLAN_LABEL: 'Plan personal',
    ENTERPRISE_QUOTE_LABEL: 'Precio acordado Enterprise',
    MANAGE_PORTAL: 'Gestionar facturación de la organización',
    MANAGE_PERSONAL_PORTAL: 'Gestionar suscripción personal',
    COMPARE_PLANS: 'Comparar planes',
    SUBSCRIPTION_STATUS: 'Estado de la suscripción',
    PERIOD_END: 'Renueva o finaliza el periodo',
    PERSONAL_BILLING_SECTION: 'Suscripción personal',
    ORG_BILLING_SECTION: 'Suscripción de la organización',
    STRIPE_NOT_CONFIGURED:
      'La facturación se está configurando. Los detalles del plan estarán disponibles pronto.',
    B2B_BILLING_RETURN_SYNCING: 'Aplicando tu pago de Stripe…',
    B2B_BILLING_RETURN_SYNCING_A11Y: 'Aplicando tu pago de Stripe',
    ORG_SEAT_TIER_LABEL: 'Nivel de plazas',
    ORG_CURRENT_SEAT_TIER_LABEL: 'Nivel de plazas actual',
    UPGRADE_SEAT_TIER: 'Mejorar',
    SEAT_TIER_UPGRADE_DIALOG_TITLE: '¿Mejorar nivel de plazas?',
    SEAT_TIER_UPGRADE_DIALOG_CONFIRM: 'Continuar al pago',
    SEAT_TIER_UPGRADE_DIALOG_CANCEL: 'Cancelar',
    SEAT_TIER_UPGRADE_DIALOG_CURRENT_PREFIX: 'Nivel de plazas actual:',
    SEAT_TIER_UPGRADE_DIALOG_TARGET_PREFIX: 'Mejorando a:',
    SEAT_TIER_UPGRADE_DIALOG_REFUND_BODY:
      'Ya pagaste tu nivel de plazas actual (inferior). Stripe acreditará o reembolsará la parte no usada de ese cargo hacia esta mejora, así que el pago refleja el importe neto (prorrateo).',
    SEAT_TIER_UPGRADE_DIALOG_SCOPE_REMINDER: WC2026_ORG_BILLING_DISCLOSURE_SHORT,
    SEAT_TIER_UPGRADE_DIALOG_CONTINUE_PROMPT: '¿Continuar?',
    NEED_CUSTOM_PLAN: '¿Necesitas un plan personalizado?',
    NEED_CUSTOM_PLAN_A11Y: 'Plan personalizado',
    PLAN_TIER_STARTER: 'Starter (gratis)',
    PLAN_TIER_PRO: 'Pro',
    PLAN_TIER_BUSINESS: 'Business',
    PLAN_TIER_ENTERPRISE: 'Enterprise',
    SUBSCRIPTION_STATUS_ACTIVE: 'Activa',
    SUBSCRIPTION_STATUS_TRIALING: 'En prueba',
    SUBSCRIPTION_STATUS_PAST_DUE: 'Vencida',
    SUBSCRIPTION_STATUS_CANCELED: 'Cancelada',
    SUBSCRIPTION_STATUS_UNPAID: 'Impagada',
    SUBSCRIPTION_STATUS_INCOMPLETE: 'Incompleta',
    SUBSCRIPTION_STATUS_INCOMPLETE_EXPIRED: 'Expirada',
    SUBSCRIPTION_STATUS_PAUSED: 'Pausada',
  },
} as const
